import { hasObservedTimeSeriesData } from "@/lib/api/observed-time-series-for-location.utils";

import type { ParameterSeriesQuerySnapshot } from "./marker-display-state";
import type { LocationParameterSeriesRequest } from "./hooks/queries";

/** Union of datapoint timestamps from settled marker-layer series queries. */
export function collectMarkerSeriesDatapointTimestamps(
  markerParameterIds: string[],
  requests: LocationParameterSeriesRequest[],
  queries: ParameterSeriesQuerySnapshot[],
): string[] {
  if (markerParameterIds.length === 0) return [];

  const parameterIdSet = new Set(markerParameterIds);
  const timestamps: string[] = [];

  for (let index = 0; index < requests.length; index++) {
    const request = requests[index];
    if (!parameterIdSet.has(request.parameterId)) continue;

    const query = queries[index];
    if (!query || query.isPending || query.isError || !query.data) continue;
    if (!hasObservedTimeSeriesData(query.data)) continue;

    const timeSeries = query.data.data;

    for (const point of timeSeries.datapoints) {
      timestamps.push(point.timestamp);
    }
  }

  return timestamps;
}

/** True when every marker-layer series query has finished loading (success or error). */
export function areMarkerSeriesQueriesSettled(
  markerParameterIds: string[],
  requests: LocationParameterSeriesRequest[],
  queries: ParameterSeriesQuerySnapshot[],
): boolean {
  if (markerParameterIds.length === 0 || requests.length === 0) return false;

  const parameterIdSet = new Set(markerParameterIds);

  for (let index = 0; index < requests.length; index++) {
    if (!parameterIdSet.has(requests[index].parameterId)) continue;
    const query = queries[index];
    if (!query || query.isPending) return false;
  }

  return true;
}
